import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API_URL;

const Cart = () => {
  const navigate = useNavigate();
  const [cart, setCart] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);

  const [details, setDetails] = useState({
    name: "",
    phone: "",
    address: "",
    pincode: "",
  });

  const user = JSON.parse(localStorage.getItem("user"));
  const cartKey = user ? `cart_${user._id}` : "guest_cart";

  useEffect(() => {
    setCart(JSON.parse(localStorage.getItem(cartKey)) || []);
  }, [cartKey]);

  const totalAmount = cart.reduce(
    (sum, i) => sum + i.price * i.quantity,
    0
  );

  const removeItem = (cartItemId) => {
    const updated = cart.filter((i) => i.cartItemId !== cartItemId);
    setCart(updated);
    localStorage.setItem(cartKey, JSON.stringify(updated));
  };

  const submitOrder = async () => {
    if (!details.name || !details.phone || !details.address || !details.pincode) {
      alert("❗ Sabhi fields bharo!");
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");

      await axios.post(
        `${API}/orders`,
        {
          customer: details,
          products: cart.map((i) => ({
            productId: i.productId,
            quantity: i.quantity,
            unit: "kg",
            price: i.price,
          })),
          totalPrice: totalAmount,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      alert("✅ Order Placed Successfully!");
      localStorage.removeItem(cartKey);
      setCart([]);
      setShowForm(false);
      navigate("/orders");
    } catch (err) {
      console.error("ORDER ERROR:", err);
      const msg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        "Order failed";
      alert("❌ " + msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-3">
      <div className="text-center mb-3">
        <h4 className="fw-bold mb-1">🛒 My Cart</h4>
        <p className="text-muted small mb-0">Review your items and place order</p>
      </div>

      {cart.length === 0 ? (
        <div className="text-center mt-5">
          <div style={{ fontSize: "48px" }}>🛒</div>
          <p className="text-muted mt-2">Cart empty hai!</p>
          <button
            className="btn btn-primary btn-sm rounded-pill px-4"
            onClick={() => navigate("/")}
          >
            Shop Now
          </button>
        </div>
      ) : (
        <>
          {/* Cart Items */}
          {cart.map((item) => (
            <div
              key={item.cartItemId}
              className="card mb-2 shadow-sm border-0 rounded-3"
            >
              <div className="card-body p-3 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-3">
                  {item.image && (
                    <img
                      src={item.image}
                      alt={item.name}
                      style={{
                        width: "50px",
                        height: "50px",
                        objectFit: "cover",
                        borderRadius: "10px",
                      }}
                    />
                  )}
                  <div>
                    <div className="fw-semibold">{item.name}</div>
                    <div className="text-muted small">
                      {(item.quantity / 1000).toFixed(2)} kg
                    </div>
                    <div className="text-success fw-bold small">
                      ₹{item.price * item.quantity}
                    </div>
                  </div>
                </div>
                <button
                  className="btn btn-outline-danger btn-sm rounded-pill"
                  onClick={() => removeItem(item.cartItemId)}
                >
                  🗑
                </button>
              </div>
            </div>
          ))}

          {/* Total */}
          <div className="card shadow-sm border-0 rounded-3 mb-3">
            <div className="card-body p-3 d-flex justify-content-between align-items-center">
              <span className="fw-semibold">Total Amount</span>
              <span className="fw-bold text-success fs-5">₹{totalAmount}</span>
            </div>
          </div>

          {/* Place Order Button */}
          {!showForm && (
            <button
              className="btn btn-success w-100 rounded-pill fw-semibold"
              onClick={() => setShowForm(true)}
            >
              🛍 Place Order
            </button>
          )}
        </>
      )}

      {/* Order Form */}
      {showForm && (
        <div className="card shadow-lg border-0 rounded-3 mt-3">
          <div className="card-body p-3">
            <h6 className="fw-bold mb-3">📋 Delivery Details</h6>

            <div className="mb-2">
              <input
                className="form-control form-control-sm rounded-3"
                placeholder="Full Name"
                value={details.name}
                onChange={(e) =>
                  setDetails({ ...details, name: e.target.value })
                }
              />
            </div>

            <div className="mb-2">
              <input
                className="form-control form-control-sm rounded-3"
                placeholder="Phone Number"
                value={details.phone}
                onChange={(e) =>
                  setDetails({ ...details, phone: e.target.value })
                }
              />
            </div>

            <div className="mb-2">
              <input
                type="number"
                className="form-control form-control-sm rounded-3"
                placeholder="Pincode"
                value={details.pincode}
                onChange={(e) =>
                  setDetails({ ...details, pincode: e.target.value })
                }
              />
            </div>

            <div className="mb-3">
              <textarea
                className="form-control form-control-sm rounded-3"
                placeholder="Full Address"
                rows={2}
                value={details.address}
                onChange={(e) =>
                  setDetails({ ...details, address: e.target.value })
                }
              />
            </div>

            <div className="d-flex gap-2">
              <button
                className="btn btn-outline-secondary btn-sm rounded-pill w-50"
                onClick={() => setShowForm(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-success btn-sm rounded-pill w-50 fw-semibold"
                onClick={submitOrder}
                disabled={loading}
              >
                {loading ? "Placing..." : "✅ Confirm Order"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;